export const environment = {
  production: false,
  firebase: {
  apiKey: "AIzaSyB0XQ4ss4hl4F1giyyy8bLKtrrWHoo2--g",
  authDomain: "bwi-farmers.firebaseapp.com",
  projectId: "bwi-farmers",
  databaseURL: "https://bwi-farmers.firebaseio.com",
  storageBucket: "bwi-farmers.appspot.com",
  messagingSenderId: "785604575228",
  appId: "1:785604575228:web:b8f680a0d740a240983c79",
  measurementId: "G-49GLW71TPL",
  },
  shopProductsLimit: 50,
  timeToUpdateAgentLocation: 30000,
  deliveryBikeurl: 'assets/img/delivery-bike.png',
  destinationMarkerUrl: 'assets/img/map-marker.png',
  razorpay: {
    description: "Kisaan24 Payment",
    currency: 'INR',
    image: 'https://farmerspoint.co/assets/img/admin-pic.png',
    theme: {
      color: '#48b287'
    }
  },
  paytm: {
    CHANNEL_ID: 'WAP',
    WEBSITE: 'DEFAULT',
    INDUSTRY_TYPE_ID: 'Retail',
    ENVIRONMENT: 'production'
  },
  envPaytmActive: false,
  storeName: "Kisaan24",
  supportPhone: '1234567890',
  scrollLimit:20,
  priceReqFeature:false,
  appSharingImg:'https://farmerspoint.co/assets/img/admin-pic.png',
  deliveryFeature: false,
  ALGOLIA_APP_ID: 'DEYL6OZL2B',
  isDeliveryBasedKm: false,
  orderIdPrefix: 'ORD',
  defaultCountryCode: '+91',
  currencyCode: 'INR',
  taxType: 'GST',
  socialSigin: false,
  defaultProductView: 'list',
  webClientId:'',
  productSharing: true,
  phoneLength: 10,
  showFooterLogo: true,
  openAlgoliaSearch:false,
  LOGGLY_API_KEY: 'dd80a702-e3cf-4633-9d38-5ee92fe68193',
  priceForRetail: false,
  referralFeature: false,
  subscriptionFeature: false,
  RFQFeature: false,
  usersScrollLimit: 20,
  limitedTimeDeal: false,
  productRatings: false,
  multiRegion: false,
  multiVendor: false,
  membership: false,
  isDeliveryBasedOnWeight: false,
  userSignature: false,
  freeTrial: false,
  isBwiClient: false,
  lockSystem: false,
  broadcastLimit:24,
  imagesLimit: 5,
  orderUploadedDocImgsLimit: 5,
  resellingFeature: false,
  shareCatalogue: false,
  qtyLeft: 5,
  allOrderStatuses: ['Pending', 'Rejected', 'Confirmed', 'Cancelled', 'Dispatched', 'Delivered', 'Returned'],
  appAccessOnApproval: false
};